"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAspect = exports.GetErrorImage = exports.ErrorImage = exports.GetEmptyImage = exports.EmptyImage = exports.Site = exports.Platform = void 0;
var website_1 = require("utils/website");
var Platform;
(function (Platform) {
    Platform["WEB"] = "web";
    Platform["MWEB"] = "mweb";
})(Platform = exports.Platform || (exports.Platform = {}));
var Site;
(function (Site) {
    Site["ADOR"] = "ADOR";
})(Site = exports.Site || (exports.Site = {}));
exports.EmptyImage = (_a = {},
    _a[Site.ADOR] = (_b = {},
        _b[Platform.WEB] = "https://i.ezbuy.sg/Fq_gswcMNQWwROASxg2SGsVmXE2z",
        _b[Platform.MWEB] = "https://i.ezbuy.sg/FrXBj5nOLxZWPGeOpI02ixCHiJcX",
        _b),
    _a);
exports.GetEmptyImage = function () {
    var platform = website_1.isPC() ? Platform.WEB : Platform.MWEB;
    return exports.EmptyImage[Site.ADOR][platform];
};
exports.ErrorImage = (_c = {},
    _c[Site.ADOR] = (_d = {},
        _d[Platform.WEB] = "https://i.ezbuy.sg/FibTB_cZNkWsEG1AXLl4caVm6ydT",
        _d[Platform.MWEB] = "https://i.ezbuy.sg/FvoovYlN3YZAJP5zH40Y0t0sdf8K",
        _d),
    _c);
exports.GetErrorImage = function () {
    var platform = website_1.isPC() ? Platform.WEB : Platform.MWEB;
    return exports.ErrorImage[Site.ADOR][platform];
};
exports.formatAspect = function (side) {
    if (typeof side === "string" && isNaN(+side)) {
        return 0;
    }
    else if (!side) {
        return 0;
    }
    return +side;
};
